import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export { run, hasPerm } from "@/lib/controls";

let cache = null;
export const useBreachMeta = () => {
  const [meta, setMeta] = useState(cache);
  const reload = useCallback(() => api.get("/breach-reports/meta").then(({ data }) => { cache = data; setMeta(data); }).catch(() => {}), []);
  useEffect(() => { if (!cache) reload(); }, [reload]);
  return meta;
};

export const useLoad = (url) => {
  const [data, setData] = useState(null);
  const load = useCallback(() => api.get(url).then(({ data: d }) => setData(d)).catch(() => setData(false)), [url]);
  useEffect(() => { load(); }, [load]);
  return [data, load];
};

export const lbl = (s) => (s ? String(s).replace(/_/g, " ").toLowerCase().replace(/^\w/, (c) => c.toUpperCase()) : "-");
export const opts = (o) => Object.entries(o || {});
export const SEV = {
  CRITICAL: "bg-red-600 text-white border-red-600", HIGH: "bg-orange-50 text-orange-700 border-orange-200",
  MEDIUM: "bg-blue-50 text-[#008080] border-blue-200", LOW: "bg-slate-50 text-slate-600 border-slate-200",
  UNDER_ASSESSMENT: "bg-white text-slate-500 border-dashed border-slate-300",
};
export const TIMER = {
  ACTIVE: "bg-amber-50 text-amber-800 border-amber-200", BREACHED: "bg-red-600 text-white border-red-600",
  COMPLETED: "bg-emerald-50 text-emerald-700 border-emerald-200", NOT_APPLICABLE: "bg-slate-50 text-slate-500 border-slate-200",
};
export const fmtLeft = (t) => {
  if (!t || t.state === "NOT_APPLICABLE") return "No 72-hour timer";
  if (t.state === "COMPLETED") return "Satisfied";
  const s = Math.abs(t.seconds_remaining || 0);
  const txt = `${Math.floor(s / 3600)}h ${Math.floor((s % 3600) / 60)}m`;
  return t.state === "BREACHED" ? `Overdue by ${txt}` : `${txt} left`;
};
export const tz = () => Intl.DateTimeFormat().resolvedOptions().timeZone;
export const fmtTs = (v, zone) => (v ? new Date(v).toLocaleString("en-GB", { timeZone: zone || undefined, dateStyle: "medium", timeStyle: "short" }) : "-");
export const nowLocal = () => { const d = new Date(); d.setMinutes(d.getMinutes() - d.getTimezoneOffset()); return d.toISOString().slice(0, 16); };
export const toIso = (local) => (local ? new Date(local).toISOString() : null);
export const download = (res, name) => {
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = (res.headers["content-disposition"] || "").match(/filename="(.+)"/)?.[1] || name;
  a.click();
  URL.revokeObjectURL(url);
};
